import React, { useState } from 'react';
import AdminSidebar from './components/AdminSidebar';
import Header from '../teacher_screen/components/Header';
import {
    Plus,
    Filter,
    MoreHorizontal,
    BookOpen,
    Users,
    ChevronDown,
    Search,
    Edit2,
    Trash2,
    Layout
} from 'lucide-react';

export default function ClassManagement() {
    const classesData = [
        { id: 1, name: 'Grade 10-A', room: 'Block B - 302', teacher: 'Dr. Sarah Johnson', students: 32, type: 'Secondary' },
        { id: 2, name: 'Grade 10-B', room: 'Block B - 305', teacher: 'Prof. Michael Smith', students: 28, type: 'Secondary' },
        { id: 3, name: 'Grade 9-C', room: 'Block A - 102', teacher: 'Emma Wilson', students: 30, type: 'Secondary' },
        { id: 4, name: 'Grade 12-A', room: 'Lab 02', teacher: 'James Davis', students: 25, type: 'Higher Secondary' },
        { id: 5, name: 'Grade 8-D', room: 'Block C - 201', teacher: 'Oliver Miller', students: 35, type: 'Secondary' },
    ];

    return (
        <div className="flex h-screen bg-[#F8FAFC] overflow-hidden font-sans">
            <AdminSidebar />

            <main className="flex-1 overflow-y-auto px-8">
                <Header
                    title="Class Management"
                    subtitle="Configure school segments, sections and classroom allocations"
                >
                    <div className="relative group">
                        <Search size={18} className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 group-focus-within:text-blue-500 transition-colors" />
                        <input
                            type="text"
                            placeholder="Find by Grade or Teacher..."
                            className="pl-11 pr-4 py-2.5 bg-white border border-gray-100 rounded-xl text-[14px] font-bold text-gray-700 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-100 transition-all w-64"
                        />
                    </div>

                    <button className="flex items-center gap-2 px-5 py-2.5 bg-blue-500 text-white rounded-xl text-[14px] font-bold shadow-lg shadow-blue-100 hover:bg-blue-600 transition-all">
                        <Plus size={18} />
                        New Section
                    </button>
                </Header>

                <div className="flex items-center gap-6 mb-10 overflow-x-auto pb-4">
                    {['All Sections', 'Primary (1-5)', 'Middle (6-8)', 'Secondary (9-10)', 'Higher $(11-12)'].map((tab, idx) => (
                        <button
                            key={idx}
                            className={`px-6 py-2.5 rounded-xl border transition-all text-[14px] font-black whitespace-nowrap ${idx === 0 ? 'bg-blue-500 text-white border-blue-500 shadow-lg shadow-blue-100' : 'bg-white text-gray-400 border-gray-100 hover:border-blue-100'
                                }`}
                        >
                            {tab}
                        </button>
                    ))}
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-10 pb-10">
                    {classesData.map((cls) => (
                        <div key={cls.id} className="bg-white rounded-[32px] border border-gray-100 shadow-sm p-8 hover:scale-[1.01] transition-all group overflow-hidden relative">
                            <div className="absolute top-0 right-0 w-24 h-24 bg-blue-50/50 rounded-bl-[80px] -mr-6 -mt-6 -z-0"></div>

                            <div className="relative z-10">
                                <span className="px-3 py-1 bg-blue-50 text-blue-500 text-[10px] font-black uppercase tracking-widest rounded-lg mb-6 inline-block">
                                    {cls.type}
                                </span>

                                <h3 className="text-[24px] font-black text-[#111827] mb-2 group-hover:text-blue-500 transition-colors leading-tight uppercase tracking-tight">{cls.name}</h3>
                                <p className="text-gray-400 font-bold mb-8 flex items-center gap-2"><Layout size={14} /> {cls.room}</p>

                                <div className="space-y-4 mb-10 p-4 bg-slate-50 rounded-2xl border border-gray-50">
                                    <div className="flex items-center justify-between">
                                        <div className="flex items-center gap-3 text-gray-500 font-bold text-[13px]">
                                            <Users size={16} className="text-blue-500" />
                                            Students
                                        </div>
                                        <span className="text-[14px] font-black text-[#111827]">{cls.students} Enrolled</span>
                                    </div>
                                    <div className="flex items-center justify-between">
                                        <div className="flex items-center gap-3 text-gray-500 font-bold text-[13px]">
                                            <BookOpen size={16} className="text-emerald-500" />
                                            Class Teacher
                                        </div>
                                        <span className="text-[14px] font-black text-[#111827]">{cls.teacher.split(' ').slice(-1)}</span>
                                    </div>
                                </div>

                                <div className="flex items-center justify-between pt-6 border-t border-gray-50">
                                    <div className="flex gap-1">
                                        <button className="p-2.5 text-gray-400 hover:text-blue-500 hover:bg-blue-50 rounded-xl transition-all"><Edit2 size={18} /></button>
                                        <button className="p-2.5 text-gray-400 hover:text-rose-500 hover:bg-rose-50 rounded-xl transition-all"><Trash2 size={18} /></button>
                                    </div>
                                    <button className="px-5 py-2.5 bg-[#111827] text-white text-[12px] font-black rounded-xl hover:bg-blue-600 transition-all uppercase tracking-widest">
                                        View Details
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))}

                    {/* Add New Placeholder */}
                    <div className="rounded-[32px] border-2 border-dashed border-gray-100 flex flex-col items-center justify-center p-8 text-center hover:border-blue-200 transition-all group cursor-pointer h-full min-h-[350px]">
                        <div className="w-16 h-16 bg-gray-50 rounded-full flex items-center justify-center mb-6 group-hover:bg-blue-50 transition-all">
                            <Plus size={32} className="text-gray-300 group-hover:text-blue-500 transition-all" />
                        </div>
                        <h4 className="text-[18px] font-black text-gray-400 uppercase tracking-widest mb-1">Create Section</h4>
                        <p className="text-[13px] font-bold text-gray-300">Add a new educational segment</p>
                    </div>
                </div>
            </main>
        </div>
    );
}
